<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="720px"
    :append-to-body="true"
    :before-close="closeDialog"
    class="formula-dialog"
  >
    <div class="content">
      <h2 class="main-title">重庆隆携小额贷款有限公司</h2>
      <h3 class="sub-title">个人贷款正常履约年化综合融资成本上限公示</h3>
       
      <!-- <h4 class="sub-title text-indent">一、收费原则</h4> -->
      <div class="text-indent paragraph">为切实保护金融消费者合法权益，提升金融服务质效，根据《个人贷款业务明示综合融资成本规定》（金规〔2026〕2号）等相关要求，本机构现就正常履约情形下的个人贷款综合融资成本上限相关事项公示如下：</div>
      <div class="text-indent paragraph">本机构发放的个人贷款实行差异化定价。正常履约情形下的个人贷款综合融资成本各息费项目均按中国人民银行有关规定折算为年化水平，且其加总水平不超过国家规定上限。其中，本机构收取的贷款利息年化水平上限分别如下：</div>
      <div class="text-indent paragraph">（1）个人消费贷款（不含信用卡贷款），一年期年化利率上限为24%，2-5年期年化利率上限为24%；</div>
      <div class="text-indent paragraph">（2）个人经营贷款，一年期年化利率上限为24%，2-5年期年化利率上限为24%；</div>
      <div class="text-indent paragraph">本公示自2026年7月28日起执行。相关事项发生变动的，本机构将另行公示。</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'FormulaDialog',
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false
    },
    openDialog() {
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss">
.formula-dialog {
  .el-dialog__body {
    padding: 0 20px 20px;
  }
}
</style>
<style lang="scss" scoped>
.formula-dialog {
  text-align: left;

  .content {
    font-size: 14px;

    .main-title {
      color: #383838;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      margin: 0 0 15px 0;
    }

    .desc-info {
      color: #383838;
      font-weight: bold;
    }

    .sub-title {
      text-align: center;
      color: #383838;
      font-weight: bold;
      font-size: 14px;
      margin: 10px 0;
    }
    
    .text-indent {
      word-break: normal;
      text-indent: 2em;
    }

    .paragraph {
      margin: 8px 0;
    }

    .mark {
      margin: 20px 0;
      text-align: right;
    }

  }
}
</style>


// WEBPACK FOOTER //
// src/components/FormulaDialog/index.vue